export default "__VITE_ASSET__C11cNhnq__"